import styled from 'styled-components';

const centerAlignWrapper = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	align-items: center;
	justify-content: center;
	flex-direction: column;
`;

export default centerAlignWrapper;
